export default class SwScrollInverter extends ContaoWebpack.Plugin {
	elements = [];

	init () {
        this.defaultRules = {
            img: {
                selector: (plugin, elem) => {
                    return elem.tagName.toLowerCase() === 'img';
                },
                invertType: 'light',
                priority: 4,
            },
            light: {
                selector: (plugin, elem) => {
                    return this.isDark(elem);
                },
                invertType: 'light',
                priority: 1,
            },
            dark: {
                selector: (plugin, elem) => {
                    return this.isLight(elem);
                },
                invertType: 'dark',
                priority: 1,
            }
        }

        this.options = {...{
            offsetX: -5,
            offsetY: 0,
            target: null,
            ignoreElements: ['header, header *'],
            activatedRules: ['img', 'light', 'dark'],
            invertRules: this.defaultRules,
        }, ...this.options}

        if (this.options.target !== null) {
            this.options.target = document.querySelector(this.options.target);
        }
        if (this.options.target === null) {
            this.options.target = this.el;
        }

		this.setupClasses()

		this.scrollTimeout = setTimeout(() => {
			this.setupClasses()
		}, 1000)

		this.scrollTimeout = null;
		document.addEventListener('scroll', () => {
			this.setupClasses()

			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout)
			}

			this.scrollTimeout = setTimeout(() => {
				this.setupClasses()
			}, 300)
		});
	}

	setupClasses() {
		let elem = document.elementFromPoint(
                this.el.offsetLeft + this.options.offsetX,
                this.el.offsetTop + this.options.offsetY
            ),
            {r, g, b} = this.getColor(this.getElementColor(this.el))

		if (elem === null || elem.tagName === undefined) {
			return;
		}

		if (elem.tagName.toLowerCase() !== 'img' && (r == 0 || g == 0 || b == 0)) {
            const ignoreSelectors = this.options.ignoreElements || [];
            const ignoreList = [];
            ignoreSelectors.forEach(sel => {
                document.querySelectorAll(sel).forEach(el => ignoreList.push(el));
            });

            const elements = document.elementsFromPoint(
                this.el.offsetLeft + this.options.offsetX,
                this.el.offsetTop + this.options.offsetY
            );

            let foundElem = null;
            for (let e of elements) {
                if (ignoreList.includes(e)) continue;
                const bg = window.getComputedStyle(e).backgroundColor;
                if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
                    foundElem = e;
                    break;
                }
            }
            if (foundElem) {
                elem = foundElem;
            }
		}

		if (elem === null || elem.tagName === undefined) {
			return;
		}

        let invertType = {
            priority: 0,
            type: null
        };

        for (let rule in this.options.invertRules) {
            let selectorFunction = typeof this.options.invertRules[rule].selector === 'string' ? window[this.options.invertRules[rule].selector] : this.options.invertRules[rule].selector;
            if (
                selectorFunction(this, elem) &&
                this.options.invertRules[rule].priority >= invertType.priority
            ) {
                invertType.type = this.options.invertRules[rule].invertType;
                invertType.priority = this.options.invertRules[rule].priority;
            }
        }

		if (elem.tagName.toLowerCase() === 'img' || invertType.type === 'light') {
			this.addLightClass();
		} else if (invertType.type === 'dark') {
			this.addDarkClass();
		}
	}

	addLightClass() {
		if (!this.options.target.classList.contains('sw-light')) {
			this.options.target.classList.remove('sw-dark');
			this.options.target.classList.add('sw-light');
		}
	}

	addDarkClass() {
		if (!this.options.target.classList.contains('sw-dark')) {
			this.options.target.classList.remove('sw-light');
			this.options.target.classList.add('sw-dark');
		}
	}

	getColor(color) {
		let r, g, b;
		if (color.match(/^rgb/)) {
			color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

			r = color[1];
			g = color[2];
			b = color[3];
		} else {
			color = +("0x" + color.slice(1).replace(
			color.length < 5 && /./g, '$&$&'));

			r = color >> 16;
			g = color >> 8 & 255;
			b = color & 255;
		}

		return {r: r, g: g, b: b};
	}

    isDark(elem) {
        let hsp = this.getHsp(elem)
        return hsp < 127.5;
    }

    isLight(elem) {
        let hsp = this.getHsp(elem)
        return hsp > 127.5;
    }

    getElementColor(elem) {
        return window.getComputedStyle(elem).backgroundColor
    }

	getHsp(elem) {
		let hsp,
            color = this.getElementColor(elem)

		const {r, g, b} = this.getColor(color)

		hsp = Math.sqrt(
			0.299 * (r * r) +
			0.587 * (g * g) +
			0.114 * (b * b)
		)

        return hsp
	}
}
